import { useRestrictionById } from '@/api/restrictions/queries';
import { ModalWithVersion } from '@/components/core/Modal/WithVersion';
import { ModalsKey } from '@/enums/modalsKey';
import { useRestrictionsForm } from '@/hooks/restrictions/useRestrictionsForm';
import useTranslation from 'next-translate/useTranslation';
import RestrictionModalContent from './Content';

export default function RestrictionModal() {
  const { t } = useTranslation('account');
  const { isCreating, id } = useRestrictionsForm();

  const { isLoadingRestriction } = useRestrictionById({
    id: Number(id),
  });

  return (
    <ModalWithVersion
      title={t(isCreating ? 'create_restriction' : 'edit_restriction')}
      modal={ModalsKey.Restriction}
      isLoading={isLoadingRestriction}
      clearParams
    >
      <RestrictionModalContent />
    </ModalWithVersion>
  );
}
